// src/composables/Applications/useSignet.ts

import { ref } from 'vue'
import useGatewayApi from './useGatewayApi'
import { DocumentStatus } from '@/types/DocumentStatus'

const api = useGatewayApi()

const signetDocument = ref<any>({ images: [] })
const coDocument = ref<any>({ images: [] })
const spinner = ref(false)
const success = ref(false)

export function useSignet() {
  async function sendLanaDocument(payload: any) {
    spinner.value = true
    if (!payload.promises) payload.promises = []

    await Promise.all(payload.promises)

    try {
      const result = await api.get(`api/v1/core/signet/create/lana`, payload)
      signetDocument.value = result
      return result
    } catch (e) {
      throw e
    } finally {
      spinner.value = false
    }
  }

  async function getDocument(docId: string) {
    spinner.value = true
    try {
      const result = await api.get(`api/v1/core/signet/sign/getdocument?docId=${docId}`)
      coDocument.value = result
      return result
    } catch (e) {
      throw e
    } finally {
      spinner.value = false
    }
  }

  async function loadDocument(docId: string) {
    const result = await getDocument(docId)
    signetDocument.value = result
    return result
  }

  async function createDocument(payload: any) {
    if (!payload.promises) payload.promises = []

    spinner.value = true
    signetDocument.value.images = []

    await Promise.all(payload.promises)

    try {
      const result = await api.post(`api/v1/core/signet/create/document`, payload)
      signetDocument.value = result
      return result
    } catch (e) {
      throw e
    } finally {
      spinner.value = false
    }
  }

async function getSigningStatus(docId: string): Promise<DocumentStatus> {
  const result = await api.get(
    `api/v1/core/signet/sign/status?docId=${encodeURIComponent(docId)}`
  )

  return result as DocumentStatus
}

  async function signInContract(payload: any) {
    const docId = signetDocument.value?.DocId || payload.docId

    let url = 'api/v1/core/signet/sign/document'
    if (payload.device === 1) {
      url = 'api/v1/core/signet/sign/document/app'
    }

    const result = await api.post(url, {
      Phone: payload.phone,
      Lang: payload.lang,
      CoSigners: payload.coSigners,
      DocId: docId,
      Umsokn: payload.application,
      Type: payload.type,
      ProjectId: payload.projectId,
      CoSigner: payload.coSigner,
      Device: payload.device
    })

    if (result?.data === false) {
      throw new Error('Signing failed')
    }

    signetDocument.value.images = []
    success.value = result?.data ?? true
      return result?.data ?? true
  }


  return {
    signetDocument,
    coDocument,
    spinner,
    success,
    sendLanaDocument,
    getDocument,
    getSigningStatus,
    loadDocument,
    createDocument,
    signInContract
  }
}
